import { LeadForm } from "../LeadForm";
import { Reveal } from "../Reveal";
import { useLang } from "../../context/LanguageContext";
import { Check } from "lucide-react";

export function LeadSection({ course }) {
  const { t } = useLang();
  const points = [t("leadsec.point1"), t("leadsec.point2"), t("leadsec.point3")];
  return (
    <section id="richiedi-informazioni" data-testid="course-lead-section" className="bg-[#F4F8FF] py-20 md:py-28">
      <div className="px-6 md:px-12 max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start">
        <Reveal>
          <span className="overline">{t("leadsec.overline")}</span>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-[#0B1220] mt-3 leading-tight">
            {t("leadsec.title")}
          </h2>
          <p className="mt-6 text-[#5C6678] font-light leading-relaxed max-w-md">
            {t("leadsec.desc")}
          </p>
          <ul className="mt-8 space-y-4">
            {points.map((p, i) => (
              <li key={i} className="flex items-start gap-3">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#1452F0]">
                  <Check className="h-3.5 w-3.5 text-[#F4F8FF]" strokeWidth={2} />
                </span>
                <span className="text-[#0B1220]/80">{p}</span>
              </li>
            ))}
          </ul>
        </Reveal>

        <Reveal delay={0.1} className="bg-[#E9EFFA] rounded-sm p-8 md:p-10 border border-[#D5DEEE]">
          <LeadForm course={course} source="landing_section" />
        </Reveal>
      </div>
    </section>
  );
}
